import React from 'react';
import styled from 'styled-components';
import { Normalize } from 'styled-normalize';
import { WrapPageElementBrowserArgs } from 'gatsby';
import GlobalStyle from './styles/global';
import ErrorModal from './components/ErrorModal';
import { NATIVE_APP_OPERATION } from './helpers/nativeAppHelper';
// If solved by the eslint suggestion we loose some focus on certain components localy. This could be solved in SELFS-4396 (see comment section)
// eslint-disable-next-line import/no-extraneous-dependencies
import 'focus-visible';
import '@ikea-customer-self-serve/ts-picker/dist/style.css';

// Skapa styles
import '@ingka/button/dist/style.css';
import '@ingka/choice/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/hyperlink/dist/style.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/loading/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/typography/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/price/dist/style.css';
import '@ingka/commercial-message/dist/style.css';
import '@ingka/price-module/dist/style.css';
import './styles/_ikea-theme-dark.css';

import { colors } from './styles';

// the font-family is temporary until we have a real header and footer
const Main = styled.main`
  max-width: 906px;
  margin: 0 auto;
  font-family:
    Noto IKEA,
    Noto Sans,
    Roboto,
    Open Sans,
    sans-serif;
  color: ${colors.text.default};
`;

const NativeStylesWrapper = styled.div`
  background: ${colors.background.default};
  min-height: 100vh;
  overflow: hidden;
`;

const PageWrapper = ({
  element,
  props,
}: WrapPageElementBrowserArgs): React.ReactElement => {
  return (
    <>
      <GlobalStyle />
      <Normalize />
      {props.pageContext.operation === NATIVE_APP_OPERATION ? (
        <NativeStylesWrapper>
          <Main>{element}</Main>
        </NativeStylesWrapper>
      ) : (
        <Main>{element}</Main>
      )}

      <ErrorModal />
    </>
  );
};

export default PageWrapper;
